import { render, staticRenderFns } from "./VisualizarRelatorio.vue?vue&type=template&id=52be5b1b&lang=pug"
import script from "./VisualizarRelatorio.vue?vue&type=script&lang=js"
export * from "./VisualizarRelatorio.vue?vue&type=script&lang=js"
import style0 from "./VisualizarRelatorio.vue?vue&type=style&index=0&id=52be5b1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports